import { Component, ElementRef } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { FieldConfig } from '@smartflip/data-models';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'lib-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  imports: [ReactiveFormsModule, IonicModule],
})
export class SelectComponent {
  field!: FieldConfig;
  group!: UntypedFormGroup;
  public formControl!: AbstractControl<unknown> | null;

  constructor(private el: ElementRef) {}

  public getFieldOptions(field: FieldConfig) {
    return field.options?.map((option) => option as string);
  }

  public scrollIntoView() {
    this.el.nativeElement.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }
}
